import { render, staticRenderFns } from "./ProfileCustomerUpdateModal.vue?vue&type=template&id=b27cafec"
import script from "./ProfileCustomerUpdateModal.vue?vue&type=script&lang=js"
export * from "./ProfileCustomerUpdateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports